import React from 'react'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { MobileNavigationItem } from '../../../../types'
import MenuHeader from '../MenuHeader'
import styles from '../styles.css'

interface NavigationListProps {
  navigationItems: MobileNavigationItem[]
  header: string
  testId: string
}

const NavigationList: React.FC<NavigationListProps> = ({ navigationItems, testId, header }) => {
  return (
    <>
      <MenuHeader header={header} />
      <ul className={styles.list} data-testid={testId}>
        {navigationItems.map((navItem, index) => {
          return (
            <div key={index}>
              {navItem.to ? (
                <NavLink
                  to={navItem.to}
                  onClick={() => navItem.onClick && navItem.onClick()}
                  className={styles.linkWrapper}
                >
                  <li
                    className={classNames(styles.listItem, {
                      [styles.lastItem]: index === navigationItems.length - 1
                    })}
                  >
                    <span className={styles.listItemContents}>{navItem.children}</span>
                  </li>
                </NavLink>
              ) : (
                <li
                  className={classNames(styles.listItem, {
                    [styles.lastItem]: index === navigationItems.length - 1
                  })}
                >
                  <span
                    onClick={() => navItem.onClick && navItem.onClick()}
                    className={styles.listItemContents}
                  >
                    {navItem.children}
                  </span>
                </li>
              )}
            </div>
          )
        })}
      </ul>
    </>
  )
}

export default NavigationList
